import { Check } from "lucide-react";
import { norwoodClasses, norwoodHeadsUrl } from "@/lib/site-core";
import { rememberNorwood } from "@/components/forms/quick-quote-shared";

export function NorwoodQuiz() {
  return (
    <section className="bg-muted py-10 md:py-12">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <p className="text-center text-sm font-semibold tracking-wide text-foreground">
          Request A Quote
        </p>
        <h2 className="mx-auto mt-3 max-w-3xl text-center text-3xl font-extrabold leading-tight text-foreground md:text-4xl">
          Which picture most closely resembles
          <br />
          your hair loss?
        </h2>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4">
          {norwoodClasses.map((c) => (
            <a
              key={c.label}
              href={norwoodHeadsUrl}
              onPointerDown={() => rememberNorwood(c.label)}
              onClick={() => rememberNorwood(c.label)}
              className="group relative flex flex-col items-center border-2 border-transparent bg-background p-6 transition-all duration-200 hover:-translate-y-1 hover:border-primary hover:bg-primary/5 hover:shadow-xl"
            >
              <span className="absolute -top-5 left-1/2 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full border-2 border-muted bg-background text-muted-foreground transition group-hover:border-primary group-hover:bg-primary group-hover:text-primary-foreground">
                <Check className="h-5 w-5" strokeWidth={3} />
              </span>
              <img loading="lazy" decoding="async" src={c.img} alt={`Norwood ${c.label} hair loss illustration`} width={204} height={130} className="mt-6 h-40 w-auto origin-center object-contain transition-transform duration-200 ease-out [transform:scale(1)] group-hover:[transform:scale(1.12)]" />
              <div className="mt-4 text-lg font-bold text-foreground transition-colors group-hover:text-primary">{c.label}</div>

            </a>
          ))}
        </div>
      </div>
    </section>
  );
}